import { filterOptions } from '@/utils/query-base'

const be = filterOptions(['EQ'])
const city = filterOptions(['EQ', 'EMPTY', 'NEMPTY', 'NE'])
const all = filterOptions(['EQ', 'EMPTY', 'NE', 'NEMPTY', 'CP', 'BT', 'GT', 'LT', 'LE', 'GE'])
const cusname = filterOptions(['EQ', 'EMPTY', 'NE', 'NEMPTY', 'CP', 'CP-S'])

export const pageSearch = {
  'zzfld00001h': {
    title: '营销单元',
    type: 'select',
    equation: all,
    dictionary: 'sale'
  }
}

export default {
  'partner1': {
    title: '客户编号1',
    type: 'dialog',
    equation: all,
    dialog: {
      component: 'ClientSelect',
      title: '客户编号1'
    }
  },
  'name1': {
    title: '客户名称1',
    type: 'input',
    equation: cusname,
    width: 250
  },
  'zzfld0000161_text': {
    title: '客户类型1'
  },
  'reltyp': {
    describe: true,
    title: '客户关系',
    type: 'select',
    equation: city,
    dictionary: 'A0100'
  },
  'partner2': {
    title: '客户编号2',
    type: 'dialog',
    equation: all,
    dialog: {
      component: 'ClientSelect',
      title: '客户编号2'
    }
  },
  'name2': {
    title: '客户名称2',
    type: 'input',
    equation: cusname,
    width: 250
  },
  'zzfld0000162_text': {
    title: '客户类型2'
  },
  'zzfld00002r2': {
    title: '客户手机2',
    type: 'input',
    equation: all
  },
  'mc_short': {
    title: '营销单元'
    // type: 'select',
    // equation: all,
    // dictionary: 'sale'
  },
  'zzfld00003e': {
    describe: true,
    title: '基地',
    type: 'select',
    equation: all,
    dictionary: 'base'
  },
  'zzfld000026': {
    title: '是否归档',
    type: 'whether',
    equation: be
  }
}



// WEBPACK FOOTER //
// ./src/views/client-manage/config/clientRelationshipReport.js